export enum ETransactionType {
    all         = -1,
    matured     = -2,
    buy         = 0,
    reinvest    = 1,
    dividend    = 2,
    topup       = 3,
    adjust      = 4,
    interest    = 5,
}

export const TransactionTypeNames : Map<ETransactionType,string> = new Map([
    [ETransactionType.all,"All"],
    [ETransactionType.matured,"Matured"],
    [ETransactionType.buy, "Buy/Sell"],
    [ETransactionType.reinvest, "Reinvest"],
    [ETransactionType.dividend, "Dividend"],
    [ETransactionType.topup, "Top-up"],
    [ETransactionType.adjust, "Adjust"],
    [ETransactionType.interest, "Interest"],
])

export const ValidTransactionTypes = new Set<number>(Array.from(TransactionTypeNames.keys()).filter(v => v>=0))

export const TransFields:Record<string,string> = {
    _id         :"_id",
    userId      :"u",
    ticker      :"i",
    type        :"t",
    date        :"d",
    quantity    :"q",
    account     :"a",
    price       :"p",
    note        :"n",
    yield       :"y",
    maturity    :"m",
}

export type TTransactionIdName = {id:ETransactionType,name:string}
export const TransactionTypes : TTransactionIdName[] = Array.from(TransactionTypeNames.entries()).filter(([key]) => key>=0).map(([id,name]) => ({id,name}))

export interface ITransRow {
    _id:string;     // transaction id
    u:string;       // userId
    i:string;       // ticker
    t:number;       // type
    d:string;       // date
    q:number;       // qty
    a:number;       // account
    p:number;       // price
    n:string;       // note
    y:number;       // yield rate
    m:string;       // maturity
}

export type TTransaction = Omit<ITransRow, "u"|"i">
export type TTransaction_LessId = Omit<TTransaction, "_id">
